// 精選可愛漸層主題設定檔
export const CARD_THEMES = {
  sakura: {
    id: 'sakura',
    nameKey: 'theme.sakura',
    dotBg: 'bg-pink-300',
    light: { bg: 'from-pink-100 to-rose-200', text: 'text-rose-700', badge: 'bg-rose-300 text-rose-900', border: 'border-white' },
    dark: { bg: 'from-pink-900/40 to-rose-900/30', text: 'text-pink-300', badge: 'bg-rose-900/60 text-rose-200', border: 'border-slate-800' }
  },
  mint: {
    id: 'mint',
    nameKey: 'theme.mint',
    dotBg: 'bg-emerald-300',
    light: { bg: 'from-emerald-100 to-teal-200', text: 'text-teal-700', badge: 'bg-teal-300 text-teal-900', border: 'border-white' },
    dark: { bg: 'from-emerald-900/40 to-teal-900/30', text: 'text-emerald-300', badge: 'bg-teal-900/60 text-teal-200', border: 'border-slate-800' }
  },
  lavender: {
    id: 'lavender',
    nameKey: 'theme.lavender',
    dotBg: 'bg-purple-300',
    light: { bg: 'from-purple-100 to-fuchsia-200', text: 'text-fuchsia-700', badge: 'bg-fuchsia-300 text-fuchsia-900', border: 'border-white' },
    dark: { bg: 'from-purple-900/40 to-fuchsia-900/30', text: 'text-purple-300', badge: 'bg-fuchsia-900/60 text-fuchsia-200', border: 'border-slate-800' }
  },
  butter: {
    id: 'butter',
    nameKey: 'theme.butter',
    dotBg: 'bg-yellow-300',
    light: { bg: 'from-amber-100 to-yellow-200', text: 'text-amber-700', badge: 'bg-yellow-300 text-amber-900', border: 'border-white' },
    dark: { bg: 'from-amber-900/40 to-yellow-900/30', text: 'text-amber-300', badge: 'bg-yellow-900/60 text-yellow-200', border: 'border-slate-800' }
  },
  sky: {
    id: 'sky',
    nameKey: 'theme.sky',
    dotBg: 'bg-sky-300',
    light: { bg: 'from-sky-100 to-blue-200', text: 'text-blue-700', badge: 'bg-blue-300 text-blue-900', border: 'border-white' },
    dark: { bg: 'from-sky-900/40 to-blue-900/30', text: 'text-sky-300', badge: 'bg-blue-900/60 text-blue-200', border: 'border-slate-800' }
  },
  elapsed: {
    id: 'elapsed',
    nameKey: 'theme.elapsed',
    dotBg: 'bg-slate-300',
    light: { bg: 'from-gray-100 to-slate-200', text: 'text-slate-600', badge: 'bg-slate-300 text-slate-700', border: 'border-white' },
    dark: { bg: 'from-slate-800 to-slate-900', text: 'text-slate-400', badge: 'bg-slate-700 text-slate-300', border: 'border-slate-700' }
  }
};

export const THEME_KEYS = ['sakura', 'mint', 'lavender', 'butter', 'sky'];

export const getThemeStyle = (themeId, status, isDark) => {
  if (status === 'elapsed') {
    return isDark ? CARD_THEMES.elapsed.dark : CARD_THEMES.elapsed.light;
  }
  const theme = CARD_THEMES[themeId] || CARD_THEMES.sakura;
  return isDark ? theme.dark : theme.light;
};